// 时间包裹（EP-005-S1）—— 统一经此进入「当前时刻」，便于测试时 mock。
// 注意：本文件是少数允许调用 Date.now 的地方之一；domain 层一律通过注入的 now() 取时间，
// 不得直接 Date.now（CI 守门 check-no-tick-accumulator 会抓 domain 内的 Date.now）。
export function now(): number {
  return Date.now();
}
